require('./bootstrap');
require('./plugins/imask');
require('./imask');
require('./masks');
require('./global');
require('./validate.min.js');
require('./validatePlus.js');
require('./theme.js');
